//Newsletter
function comprueba(){
	if(check.checked){
	 document.getElementById("Subscribe").disabled = false;
     document.getElementById("Email").focus();
	}
	else{
	 document.getElementById("Subscribe").disabled = true;
	}
}
 
$(document).ready(function() {
  if(document.getElementById('newsletter_form')) {
  	 var check = document.getElementById('check');
  document.getElementById("Subscribe").disabled = true;
 if (!check) {
	 return;
 } else {
	 check.addEventListener("change", comprueba, false);
 }
  }

});



//Filtros catalogo completo
setTimeout(function(){
if ( document.querySelector( "#shopify-section-collection-template" )) {
	
  var categorias = $('.advanced-filters');
  
  categorias.each(function (index) {
    var $this = $(this);
   	var children = $this.children('li');
    
    children.each(function (index) {
           if ($(this).hasClass('disabled')) {
           	$(this).remove();
           }
          })
   })
  
  categorias.each(function (index) {
  	var $this = $(this);
    var children = $this.children('li');
    var items = 4;
    
    if(children.length > items) {
      children.each(function (index) {
        if(index < 5) {
          $(this).removeClass("toggleable");
          $(this).css('display', 'block');
        }
      })
    }
    
    if(children.length <= 6) {
      children.each(function (index) {
        if($(this).hasClass('open-more-container')) {
        	$(this).remove();
        }             
      })
    }
         
  })
  
  
  numerically_ignore_letters = function(a,b){
        var non_digits = '^(\d)*';
        var a_val = parseInt( $('a', a).text().replace( non_digits, '' ), 10 );
        var b_val = parseInt( $('a', b).text().replace( non_digits, '' ), 10 );

        return  a_val - b_val;
      }
        
        elementos = $('ul.advanced-filters');
        elementos.each(function(){
          // Ordenar numéricamente los filtros
          $(this).children('li').sort( numerically_ignore_letters ).prependTo($(this));
        });
  

}
}, 300)